import {useEffect} from "react";
import {batch, useSignal} from "@preact/signals-react";
import {useAppToast} from "@ui-seeker/app";
import {postSubmit} from "@ui-seeker/utils";

import {commonFiltersValue, isLoadingCommonFilters} from "@signals";
import {BACKEND_APIS} from "@constants";
import { elementsInLoading } from "../../@signals";


export default function useSkuDetailsProductDetailsData() {
	const { showToast } = useAppToast()

	const data = useSignal({})
    const isLoadingProductDetails = useSignal(false)
    const skuID = useSignal(null)

    useEffect(() => {
		if (isLoadingCommonFilters.value) batch(() => {
			data.value = {}
            isLoadingProductDetails.value = true
			postSubmit(`${BACKEND_APIS.SKU_DETAILS}/product`, { ...commonFiltersValue.value }).then(res => {
				data.value = res
                skuID.value = res.skuID
			}).catch(() => showToast.error()
			).finally(() => {
                isLoadingProductDetails.value = false
			})
		})
	}, [isLoadingCommonFilters.value]);

	useEffect(() => {
		if (isLoadingProductDetails.value)
			elementsInLoading.value = [...elementsInLoading.value, 'productDetails']
		else{
			elementsInLoading.value = elementsInLoading.value.filter(item => item !== 'productDetails')
		}
	}, [isLoadingProductDetails.value])

	return {
		productDetailsData: data.value,
        isLoadingProductDetails: isLoadingProductDetails.value,
        skuID: skuID.value
	}
}